<template>
    <div>
        <modal :show.sync="addProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar mano de obra</h6>
                <div class="form-group">
                    <label>Detalle *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="detalle"
                                placeholder="detalle"
                                autocomplete="off"
                                v-validate="modelValidations.labourName"
                                :error="getError('detalle')"
                                v-model="labourName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Número de jornales o Kg recolectados</label>
                    <fg-input   tabindex="2"
                                type="number"
                                name="número de jornales"
                                placeholder="número de jornales"
                                autocomplete="off"
                                v-validate="modelValidations.labourQty"
                                :error="getError('número de jornales')"
                                v-model="labourQty">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Costo día/semana/kilogramo recolectado</label>
                    <vue-numeric  :max=999999999 tabindex="8" currency="$" autocomplete="off" name="costo" v-validate="modelValidations.labourValue" :error="getError('costo')" separator="." class="form-control" v-model="labourValue"></vue-numeric>
                    <span v-show="errors.has('costo')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('costo') }}
                    </span>
                </div>
                <div class="form-group">
                    <label>Total</label>
                    <vue-numeric  :max=99999999999999 tabindex="8" currency="$" autocomplete="off" name="total" v-validate="modelValidations.labourTotal" :error="getError('total')" separator="." class="form-control" v-model="labourTotalComputed"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Periodicidad</label>
                    <fg-input   tabindex="1"
                                name="periodicidad"
                                v-validate="modelValidations.labourPeriodicity"
                                :error="getError('periodicidad')"
                                v-model="labourPeriodicity">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="labourPeriodicity">
                            <el-option
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Bimensual"
                                    label="Bimensual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Trimestral"
                                    label="Trimestral">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Semestral"
                                    label="Semestral">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Anual"
                                    label="Anual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Seleccionar mes"
                                    label="Seleccionar mes">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div v-if="labourPeriodicity == 'Seleccionar mes'" class="form-group">
                    <label>Seleccione mes (Periodicidad)</label>
                    <el-date-picker
                        v-model="labourPeriodicityDate"
                        type="month"
                        placeholder="Seleccione mes (periodicidad)">
                    </el-date-picker>
                </div>
                <div class="form-group">
                    <label>Mes inicio periodicidad</label>
                    <el-date-picker
                        v-model="labourDate"
                        type="month"
                        placeholder="Seleccione mes inicio periodicidad">
                    </el-date-picker>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addProductToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar mano de obra</h6>
            <div class="form-group">
                    <label>Detalle *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="detalle"
                                placeholder="detalle"
                                autocomplete="off"
                                v-validate="modelValidations.labourName"
                                :error="getError('detalle')"
                                v-model="labourName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Número de jornales o Kg recolectados</label>
                    <fg-input   tabindex="2"
                                type="number"
                                name="número de jornales"
                                placeholder="número de jornales"
                                autocomplete="off"
                                v-validate="modelValidations.labourQty"
                                :error="getError('número de jornales')"
                                v-model="labourQty">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Costo día/semana/kilogramo recolectado</label>
                    <vue-numeric  :max=999999999 tabindex="8" currency="$" autocomplete="off" name="costo" v-validate="modelValidations.labourValue" :error="getError('costo')" separator="." class="form-control" v-model="labourValue"></vue-numeric>
                    <span v-show="errors.has('costo')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('costo') }}
                    </span>
                </div>
                <div class="form-group">
                    <label>Total</label>
                    <vue-numeric  :max=99999999999999 tabindex="8" currency="$" autocomplete="off" name="total" v-validate="modelValidations.labourTotal" :error="getError('total')" separator="." class="form-control" v-model="labourTotalComputed"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Periodicidad</label>
                    <fg-input   tabindex="1"
                                name="periodicidad"
                                v-validate="modelValidations.labourPeriodicity"
                                :error="getError('periodicidad')"
                                v-model="labourPeriodicity">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="labourPeriodicity">
                            <el-option
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Bimensual"
                                    label="Bimensual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Trimestral"
                                    label="Trimestral">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Semestral"
                                    label="Semestral">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Anual"
                                    label="Anual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Seleccionar mes"
                                    label="Seleccionar mes">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div v-if="labourPeriodicity == 'Seleccionar mes'" class="form-group">
                    <label>Seleccione mes (Periodicidad)</label>
                    <el-date-picker
                        v-model="labourPeriodicityDate"
                        type="month"
                        placeholder="Seleccione mes (periodicidad)">
                    </el-date-picker>
                </div>
                <div class="form-group">
                    <label>Mes inicio periodicidad</label>
                    <el-date-picker
                        v-model="labourDate"
                        type="month"
                        placeholder="Seleccione mes inicio periodicidad">
                    </el-date-picker>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editProductToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Hoja de trabajo</h4>
        </div>
        <!-- Inventory -->
        <card  class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">MANO DE OBRA DE LA UNIDAD PRODUCTIVA AGROPECUARIA</h6>
                <h5 class="card-subtitle" style="color: #b0b0b0; font-size: 0.9rem;">(Ordeño / rodeada / pelada de pollos / recolección / labores culturales)</h5>
            </div>
            <div class="card-body">
                <el-table v-if="products.length" :data="products"  ref="productsTable"  highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <p>Detalle:{{ props.row.labourName }}</p>
                            <p>Número de jornales: {{ props.row.labourQty }}</p>
                            <p>Costo: {{ setFormat(props.row.labourValue) }}</p>
                            <p>Total: {{ setFormat(props.row.labourTotal) }}</p>
                            <p>Periodicidad: {{ props.row.labourPeriodicity }}</p>
                            <p>Mes seleccionado (Periodicidad): {{ formatDate(props.row.labourPeriodicityDate) }}</p>
                            <p>Mes inicio periodicidad: {{ formatDate(props.row.labourDate) }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="Detalle" property="labourName"></el-table-column>
                    <el-table-column label="Total">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.labourTotal )}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                
                <div>
                    <p-button 
                        v-if="products.length < 6"
                        @click="addProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar mano de obra
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="editProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar mano de obra
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="removeProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar mano de obra
                    </p-button>
                </div>
            </div>
            <div class="card-footer">
                <div v-if="totalInventory != 0" class="alert alert-warning mt-2">
                    <span>Valor total mano de obra: {{ setFormat(totalInventory)}}</span>
                </div>
            </div>
        </card>
        <div class="text-right">
            <p-button @click="saveData()" type="warning">Siguiente</p-button>
            <p-button @click="toAgroExpenses()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Select, Option, Table, TableColumn, DatePicker} from 'element-ui'
    import Expenses from 'src/util/Others/OperatingExpenses'
    import Taxes from 'src/util/Services/Taxes'
    import moment from 'moment'
    import { Validator } from "vee-validate";

    // Regla personalizada para validar ausencia de emojis
    Validator.extend('max_decimals', {
        validate: (value, [maxInteger, maxDecimals]) => {
            const regex = new RegExp(`^\\d{1,${maxInteger}}(\\.\\d{1,${maxDecimals}})?$`);
            return regex.test(value);
        },
        getMessage: (field, [maxInteger, maxDecimals]) =>
            `${field} debe tener máximo ${maxInteger} dígitos enteros y ${maxDecimals} decimales.`
    });
    Validator.extend('no_leading_zeros', {
        validate: (value) => {
            value = String(value).trim();

            // Permitir exactamente "0"
            if (value === '0') return true;

            // No permitir ceros a la izquierda (excepto "0" como único valor)
            if (/^0\d+/.test(value)) return false;

            // Rechazar números que son exactamente 0.0000 (o equivalentes)
            if (parseFloat(value) === 0) return false;

            // Debe ser un número válido (enteros o decimales positivos)
            return /^\d+(\.\d+)?$/.test(value);
        },
        getMessage: field => `${field} no debe tener ceros a la izquierda.`
    });
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(Table)
    Vue.use(TableColumn)
    export default {
        components: {
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal,
            [DatePicker.name]: DatePicker,
        },
        data() {
        return {
            cashFlowData: null,
            form: {
                average_selection: '',
            },
            operatingSwitches: {
                expenses: false,
                inventory: false,
            },
            microcredit: false,
            consumer: false,
            pyme: false,
            expenses : [],
            actualExpenses: [],
            currentRow: null,
            addExpense: false,
            editExpense: false,
            addExpenseIndex: null,
            addProduct: false,
            editProduct: false,
            addProductIndex: null,
            monthlyNumber: '',
            labourName: '',
            labourQty: '',
            labourValue: '',
            labourTotal: '',
            labourPeriodicity: '',
            labourPeriodicityDate: '',
            labourDate: '',
            referenceDescription: '',
            products: [
                
            ],
            costs: [],
            average: {
                good_sale: '',
                bad_sale: '',
                regular_sale: '',
                average_sales: '',
                monthly_average_sales: ''
            },
            modelValidations: {
                labourName: {
                    required: true,
                    max: 50,
                    regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]*$/
                },
                labourQty: {
                    required: false,
                    max_decimals: [6,2],
                    no_leading_zeros: true
                },
                labourValue: {
                    required: false
                },
                labourTotal: {
                    required: false
                },
                labourPeriodicity: {
                    required: false
                },
                labourPeriodicityDate: {
                    required: false
                },
                labourDate: {
                    required: false
                }
            },
        }
        },
        watch: {
            labourPeriodicity: function(newVal) {
                if (newVal != 'Seleccionar mes') {
                    this.labourPeriodicityDate = '';
                }
            }
        },
        computed: {

            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             totalInventory() {
                var sum = 0;
                for (let i = 0;i<this.products.length;i++) {
                    sum = sum + this.products[i].labourTotal; 
                }
                return sum
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            labourTotalComputed () {
                if(this.labourValue != '' && this.labourQty != '') {
                    this.labourTotal = parseFloat(this.labourValue) * parseFloat(this.labourQty);
                    return this.labourTotal;
                }
                else {
                    this.labourTotal = 0;
                    return 0
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            verifyNext () {
                if (!this.operatingSwitches.expenses && !this.operatingSwitches.inventory) {
                    return true
                }
                else if(this.operatingSwitches.expenses && this.operatingSwitches.inventory &&  this.allExpensesMonthlyCostComputed != 0 && this.totalInventory != 0) {
                    return true
                }
                else if(this.operatingSwitches.expenses  &&  this.allExpensesMonthlyCostComputed ) {
                    if(!this.operatingSwitches.inventory) {
                        return true
                    }
                }
                else if(this.operatingSwitches.inventory  &&  this.totalInventory ) {
                    if(!this.operatingSwitches.expenses) {
                        return true
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productCostTotalComputed() {
                var total = this.productQuantity * this.productSaleUnity;
                this.productCostTotal = total;
                return total;
            },
            
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productMonthlyCostComputed() {
                var total = 0;
                if (this.monthlyNumber != '') {
                    var total = this.productQuantity * this.productCostUnity * this.monthlyNumber;
                    this.productMonthlyCost = total;
                }
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allExpensesMonthlyCostComputed() {
                var sum = 0;
                for (let i=0;i<this.actualExpenses.length;i++) {
                    sum = sum + (this.actualExpenses[i].value);
                }
                return sum   
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allCostsComputed() {
                return this.allExpensesMonthlyCostComputed
            }
        },
        methods: {
            initializeLabourInMonths(labourData, months) {
                console.log("📢 Inicializando mano de obra en cada mes...");

                let updatedMonths = JSON.parse(JSON.stringify(months));

                // 📌 Inicializar el total acumulado de mano de obra
                let totalizedLabour = 0;

                updatedMonths.forEach(month => {
                    // 1️⃣ Inicializar el total de mano de obra en 0 para cada mes
                    month.labourExpenses = 0;

                    console.log(`✅ ${month.name}: LabourExpenses inicializado en 0.`);
                });

                console.log("✅ Mano de obra inicializada correctamente.");
                console.log("📌 Totalized Labour inicializado en 0:", totalizedLabour);

                return { updatedMonths, totalizedLabour };
            },
            assignLabourToMonths(labourData, updatedMonths, totalizedLabour) {
                console.log("📢 Asignando valores de mano de obra a los meses...");

                labourData.forEach(labour => {
                    let startDate = new Date(labour.labourDate);
                    let labourTotal = parseInt(labour.labourTotal);
                    let periodicity = labour.labourPeriodicity;
                    let selectedMonthDate = labour.labourPeriodicityDate ? new Date(labour.labourPeriodicityDate) : null;

                    console.log(`🛠️ Procesando mano de obra: ${labour.labourName} | Periodicidad: ${periodicity} | Fecha Inicio: ${startDate.toDateString()}`);

                    // 📌 Si es "Seleccionar mes", asignamos SOLO en el mes especificado
                    if (periodicity === "Seleccionar mes" && selectedMonthDate) {
                        let selectedMonthName = this.getMonthName(selectedMonthDate.getMonth() + 1);
                        let selectedYear = selectedMonthDate.getFullYear().toString().slice(-2);
                        let selectedMonthKey = `${selectedMonthName}/${selectedYear}`;

                        let monthEntry = updatedMonths.find(m => m.name === selectedMonthKey);
                        if (monthEntry) {
                            console.log(`💰 Asignando ${labourTotal} a ${selectedMonthKey} porque es "Seleccionar mes".`);
                            monthEntry.labourExpenses += labourTotal;
                            totalizedLabour += labourTotal;
                        } else {
                            console.log(`⚠️ No se encontró el mes ${selectedMonthKey} en los datos.`);
                        }

                        return; // ⬅️ Terminamos aquí, ya que no hay más meses en este caso
                    }

                    // 📌 Encontrar el primer mes válido si no es "Seleccionar mes"
                    let firstValidMonth = updatedMonths.find(month => {
                        let [monthName, year] = month.name.split("/");
                        let monthIndex = this.getMonthIndex(monthName);
                        let fullYear = parseInt("20" + year);

                        return new Date(fullYear, monthIndex - 1, 1) >= startDate;
                    });

                    if (!firstValidMonth) return;

                    let currentMonthName = firstValidMonth.name;

                    // 📌 Aplicar la periodicidad correctamente
                    while (currentMonthName) {
                        let monthEntry = updatedMonths.find(m => m.name === currentMonthName);
                        if (!monthEntry) break;

                        console.log(`💰 Sumando ${labourTotal} a ${monthEntry.name}`);

                        // 🛠️ Sumar el valor al mes correspondiente
                        monthEntry.labourExpenses += labourTotal;

                        // 🛠️ Sumar al total global
                        totalizedLabour += labourTotal;

                        // 🔄 Buscar el siguiente mes según la periodicidad
                        let prevMonth = currentMonthName; // Debugging
                        currentMonthName = this.getNextMonth(currentMonthName, periodicity, updatedMonths);

                        console.log(`🔄 ${prevMonth} → ${currentMonthName} (Periodicidad: ${periodicity})`);
                    }
                });

                console.log("✅ Mano de obra asignada correctamente.");
                console.log("📌 Totalized Labour Final:", totalizedLabour);

                return { updatedMonths, totalizedLabour };
            },
            getNextMonth(currentMonth, periodicity, validMonths) {
                let [month, year] = currentMonth.split("/");
                let monthIndex = this.getMonthIndex(month);
                let fullYear = parseInt("20" + year);

                let monthsToAdd = {
                    "Mensual": 1,
                    "Bimensual": 2,
                    "Trimestral": 3,
                    "Semestral": 6,
                    "Anual": 12,
                    "Seleccionar mes": 0  // No avanza si es un solo mes específico
                }[periodicity] || 1; 

                if (monthsToAdd === 0) return null; // No avanza si es un mes fijo

                // 📌 Incrementar el mes según la periodicidad
                monthIndex += monthsToAdd;

                // 📌 Si pasamos diciembre, incrementamos el año
                if (monthIndex > 12) {
                    monthIndex -= 12;
                    fullYear += 1;
                }

                // 📌 Convertir el índice del mes de vuelta a su nombre
                let nextMonthName = this.getMonthName(monthIndex);
                let nextMonth = `${nextMonthName}/${String(fullYear).slice(-2)}`;

                return validMonths.some(m => m.name === nextMonth) ? nextMonth : null;
            },
            getMonthIndex(monthName) {
                const months = {
                    "Enero": 1, "Febrero": 2, "Marzo": 3, "Abril": 4, "Mayo": 5, "Junio": 6,
                    "Julio": 7, "Agosto": 8, "Septiembre": 9, "Octubre": 10, "Noviembre": 11, "Diciembre": 12
                };
                return months[monthName] || -1; // Retorna -1 si el mes no es válido
            },
            getMonthName(monthIndex) {
                const months = [
                    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
                ];
                return months[monthIndex - 1] || null; // Retorna null si el índice no es válido
            },

            toAgroExpenses(){
                this.$router.push('/asessments/new_asessment/customer/agro/expenses');
            },
            formatDate(date) {
                if (!date) return '';
                const formattedDate = new Date(date).toLocaleDateString('es-ES', {
                year: 'numeric',
                month: '2-digit'
                });
                return formattedDate;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productValidator (product) {
                if (this.$store.state.isCustomer) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = true;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    
                }
                else if(this.$store.state.isSpouse) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = true;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    
                }
                if (this.$store.state.isGuarantor) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseToList () {
                if (this.expenseName == '') {
                    this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                }
                else {
                    var index = this.actualExpenses.indexOf(this.currentRow);
                    this.actualExpenses[index].name = this.expenseName;
                    this.actualExpenses[index].value = this.expenseValue;
                    this.resetExpense();
                    this.currentRow = null;
                    this.$refs.expensesTable.setCurrentRow();
                    this.editExpense = false;
                    this.showNotificationSuccess('Gasto editado correctamente');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseMethod (row) {
                // this.addProductIndex = row;
                this.addExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        this.products.push({
                            labourName: this.labourName,
                            labourQty: this.labourQty,
                            labourValue: parseFloat(this.labourValue) || 0,
                            labourTotal: parseFloat(this.labourTotal) || 0,
                            labourPeriodicity: this.labourPeriodicity,
                            labourPeriodicityDate: this.labourPeriodicityDate,
                            labourDate: this.labourDate
                        })
                        this.resetProduct();
                        this.addProduct = false;
                        this.errors.clear();
                        this.showNotificationSuccess('Mano de obra agregada correctamente');
                        }
                        else {
                            console.error('Error: Campos no diligenciados correctamente');
                            console.log('Errores de validación:', this.errors.items); // Muestra los errores específicos
                            this.errors.items.forEach(error => {
                                console.log(`Campo: ${error.field}, Mensaje: ${error.msg}`);
                            });
                            this.showNotificationError('Campos no diligenciados correctamente');
                        }
                })

            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetProduct () {
                this.labourName = '';
                this.labourQty = '';
                this.labourValue = '';
                this.labourTotal = '';
                this.labourPeriodicity = '';
                this.labourPeriodicityDate = '';
                this.labourDate = '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductMethod () {
                this.labourName =  this.currentRow.labourName;
                this.labourQty =  this.currentRow.labourQty;
                this.labourValue =  this.currentRow.labourValue;
                this.labourTotal =  this.currentRow.labourTotal;
                this.labourPeriodicity =  this.currentRow.labourPeriodicity;
                this.labourPeriodicityDate =  this.currentRow.labourPeriodicityDate;
                this.labourDate =  this.currentRow.labourDate;
                this.editProduct = true;  
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeProductMethod () {
                this.products.splice(this.products.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                            var index = this.products.indexOf(this.currentRow);
                            this.products[index].labourName = this.labourName;
                            this.products[index].labourQty = this.labourQty;
                            this.products[index].labourValue = parseFloat(this.labourValue) || 0;
                            this.products[index].labourTotal = parseFloat(this.labourTotal) || 0;
                            this.products[index].labourPeriodicity = this.labourPeriodicity;
                            this.products[index].labourPeriodicityDate = this.labourPeriodicityDate;
                            this.products[index].labourDate = this.labourDate;
                            this.resetProduct();
                            this.currentRow = null;
                            this.$refs.productsTable.setCurrentRow();
                            this.editProduct = false;
                            this.errors.clear();
                            this.showNotificationSuccess('Mano de obra editada correctamente');
                        }
                })
                
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod (row) {
                this.addProductIndex = row;
                this.errors.clear();
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddProduct () {
                this.addProduct = false;
                this.errors.clear();
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditProduct () {
                this.editProduct = false;
                this.errors.clear();
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetItem () {
                this.itemName = '';
                this.itemPurchasePrice = '';
                this.itemSalePrice = '';
                this.itemPercent = '';
                this.productName= '';
                this.productQuantity= '';
                this.productCostUnity= '';
                this.productSaleUnity= '';
                this.productCostTotal= '';
                this.productMonthlyCost= '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseToList () {
                if (this.expenseName == '') {
                    this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                }
                else {
                    var id = this.actualExpenses.length + 1;
                    this.actualExpenses.push({
                        id: id,
                        name: this.expenseName,
                        value: this.expenseValue,
                        locked: false
                    })
                    this.resetExpense();
                    this.addExpense = false;
                    this.showNotificationSuccess('Gasto agregado correctamente');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetExpense () {
                this.expenseName = '';
                this.expenseValue = '';   
                this.expenseLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod () {
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseMethod () {
                this.expenseName= this.currentRow.name;
                this.expenseValue= this.currentRow.value;
                this.expenseLocked = this.currentRow.locked;
                this.editExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeExpenseMethod () {
                this.actualExpenses.splice(this.actualExpenses.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddExpense () {
                this.addExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditExpense () {
                this.editExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toOperatingExpenses () {
                this.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toRequestData () {
                this.$router.push('/asessments/new_asessment/customer/request_data');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             saveData () {
                if (this.products.length != 0) {
                    let { updatedMonths, totalizedLabour } = this.initializeLabourInMonths(this.products, this.cashFlowData.months);
                    ({ updatedMonths, totalizedLabour } = this.assignLabourToMonths(this.products, updatedMonths, totalizedLabour));
                    const payload = {
                        products: this.products,
                        months: updatedMonths,
                        totalizedLabour: totalizedLabour
                    };
                    this.$store.dispatch('setAgroLabour', payload).then(()=>{
                        this.$router.push('/asessments/new_asessment/customer/agro/another_expenses');
                    });
                }
                else {
                    this.showNotificationError('Debe ingresar datos de mano de obra');
                    // this.$router.push('/asessments/new_asessment/customer/others/additional_information');
                }
            }
        },
        mounted () {
            if (this.$store.state.isCustomer) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.labour) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.labour;
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlowData;
            }
            else if (this.$store.state.isSpouse) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.labour) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.labour;
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.cashFlowData;
            }
            else if (this.$store.state.isGuarantor) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.labour) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.labour;
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlowData;
            }
        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
</style>
